import { Link } from "react-router-dom";
import {  useState,useEffect } from 'react'
import { Layout, Menu } from 'antd';
import Login from './login'
import req from '../request'
import './index.css';

const { Header, Content, Footer } = Layout;

const App = props => {
    const [logined, setLogined] = useState(null)
    useEffect(()=>{
        req.logined(t=>setLogined(t))
    },[])

    if (logined === false)
        return <Login />
    else if(logined === null)
        return <></>
    else
        return <Layout>
        <Header>
            <div className="logo" />
            <Menu theme="dark" mode="horizontal">
                <Menu.Item key={1}><Link to='/'>首页</Link></Menu.Item>
                <Menu.Item key={2}><Link to='/users'>用户</Link></Menu.Item>
            </Menu>
        </Header>
        <Content style={{ padding: '0 50px', paddingTop:'20px', }}>
            <div className="site-layout-content">{props.children}</div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>2021 Zuosai.inc</Footer>
    </Layout>
}

export default App